import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Button, Modal, ModalBody } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from '../../assets/styles/style.sass';
import s2 from './dialog.sass';
import { setIsShowExtraMessageDialog } from '../../actions/dialog';

class extraMessageDialog extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setIsShowExtraMessageDialog: PropTypes.func.isRequired,
    modal: PropTypes.bool.isRequired,
    message: PropTypes.string,
  };
  static defaultProps = {
    message: '',
  };
  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      modelDataLocale: require(`../../assets/json/${lang}/${fileLang}setting/general/locale.json`),
    };
  }
  render() {
    let message = [];
    if (this.props.message !== '') {
      message = this.props.message
        .toString()
        .replace(/\u21B5/g, '&lt;br &gt;')
        .toString()
        .split('\n');
    }
    return (
      <div id="blacklist">
        <Modal
          size="lg"
          className={`${s2.dialog} ${s2.infoPopup}`}
          isOpen={this.props.modal}
          toggle={() => {
            this.props.setIsShowExtraMessageDialog();
          }}
        >
          <Button
            outline
            color="link"
            className={`${s.infoCloseRightButton} ${s2.dialogOverlayClose} ${
              s2.orderCancelcloseRightButton
            }`}
            onClick={() => {
              this.props.setIsShowExtraMessageDialog();
            }}
          />
          <ModalBody
            className={`${s2.infoContainer} ${s2.orderCancelContainer}`}
            style={{ padding: 0 }}
          >
            <div className={s2.infoContent}>
              {message.map((i, index) => (
                <span key={index.toString()}>
                  {' '}
                  {i} <br />
                </span>
              ))}
              <Button
                className={`${s.button} ${s.secondary} `}
                style={{ width: '40%', float: 'right' }}
                onClick={() => {
                  this.props.setIsShowExtraMessageDialog();
                }}
              >
                {this.state.modelDataLocale.error_wrong_modal_okay_btn}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  modal: state.dialog.isShowExtraMessageDialog,
});
const mapDispatch = {
  setIsShowExtraMessageDialog,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(extraMessageDialog),
);



// WEBPACK FOOTER //
// ./src/components/Dialog/extraMessageDialog.js